import React from 'react'
import Button, { ButtonProps } from 'react-bootstrap/Button'

const PrintButton = (props: ButtonProps): React.ReactElement => (
  <Button variant='primary' onClick={window.print} {...props}>
    Print
  </Button>
)
export default PrintButton
